import { useState } from 'react'
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from '@mui/material';
import { useSnackbar } from 'notistack';
import { trackActivity } from '../../../../utils/mixpanel';
import { regexConstants } from '../../../../constants/regEx';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import moment from 'moment';
import { backendDateFormat, fieldDateFormat } from '../../../../constants';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { globalPostService, globalPutService } from '../../../../utils/globalApiServices';
import { checkApiStatus } from '../../../../utils';
import { addHolidayListApi, updateHolidayListApi } from '../apiService';


const HolidayCru = ({ holidayListCRU, modeType, getResponseBack, onToggleModal, calenderSlug, calenderDetail }) => {
    const { enqueueSnackbar } = useSnackbar();
    const [data, setData] = useState({ ...holidayListCRU?.data });
    const [isLoading, setLoading] = useState(false);
    const [error, setError] = useState({});

    const onFieldChange = (keyParam, value) => {
        setData({ ...data, [keyParam]: value })
    }
    
    const onAddEditHolidayList = () => {
        let validationInputs = {
            name: data?.name?.trim() ? "" : "Please enter Name",
            date: data?.date ? "" : "Please enter Date",
        };

        const HolidayDate = moment(data?.date);

        if (data?.date && !HolidayDate.isValid()) {
            validationInputs.date = "Please enter valid Date";
        }
        if (data?.date && HolidayDate.isBefore(calenderDetail?.effective_from)){
            validationInputs.date = "Date cannot be before Effective From";
        }
        if (data?.date && HolidayDate.isAfter(calenderDetail?.effective_till)){
            validationInputs.date = "Date cannot be After Effective Till";
        }
    
        if (!Object.values(validationInputs).every(v => v === "")) {
            setError(validationInputs);
            trackActivity(`Item ${modeType === 'add' ? 'Added' : 'Edited'}`, { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Holiday List`, error_msg: validationInputs, })  
            return;
        }

        const payload = {
            name: data?.name || null,
            calendar_slug: calenderSlug,
            date: data?.date || null,
            notes: data?.notes || null,
        };

        setLoading(true);
        const apiCall = data?.id
            ? globalPutService(updateHolidayListApi({ holiday_slug: data?.slug, calenderSlug }), payload)
            : globalPostService(addHolidayListApi({ calenderSlug }), payload);

        apiCall.then(response => {
            setLoading(false);
            if (checkApiStatus(response)) {
                enqueueSnackbar(response?.data?.message, { variant: "success" });
                onToggleModal();
                getResponseBack();
                trackActivity(data?.id ? 'Item Edited' : 'Item Added', {
                    page_title: 'Calendar Detail Holiday List',
                    payload
                });
            } else {
                enqueueSnackbar(response?.data?.message, { variant: "error" });
            }
        });
    };

    const onRestErrorKey = (keyParam) => {
        setError(prev => ({ ...prev, [keyParam]: '' }))
    }

    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Holiday List`, page_type: page_type, })
    }
    return (
        <>
            <Dialog aria-labelledby="customized-dialog-title" className="add-lease-dialog" maxWidth="md" open={true} fullWidth>
                <DialogTitle sx={{ m: 0, p: 2, pl:3 }} className='dialog-header'>
                    {modeType === "add" ? "Add Holiday List" : modeType === "edit" ? "Edit Holiday List" : "View Holiday List"}
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={2}>
                        <Grid size={{ md: 6, xs: 12 }}>
                            <TextField
                                disabled={modeType === "view"}
                                id="name"
                                label="Name"
                                variant="outlined"
                                size="small"
                                margin="normal"
                                onChange={(e) => { regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange('name', e.target.value.trimStart()) : e.preventDefault() }}
                                onFocus={() => onRestErrorKey("name")}
                                slotProps={{ inputLabel: { shrink: true }, htmlInput: {maxLength: 100} }}
                                value={data?.name || ''}
                                error={!!error.name}
                                helperText={error.name}
                                fullWidth
                                required
                            />
                        </Grid>
                        <Grid size={{ md: 6, xs: 12 }}>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <DatePicker
                                    label="Date"
                                    value={data?.date ? moment(data.date) : null}
                                    onChange={(data) => {
                                        const isValid = moment(data)?.isValid();
                                        onFieldChange("date", data ? moment(data).format(backendDateFormat) : null);
                                        if (isValid) {
                                            onRestErrorKey("date");
                                        }
                                    }}
                                    slotProps={{
                                        textField: {
                                            required: true,
                                            InputLabelProps: { shrink: true },
                                            error: error.date || false,
                                            helperText: error.date || '',
                                            onFocus: () => {
												if (error.date) {
													onRestErrorKey("date");
												}
											},
                                            size: "small",
                                            margin: "normal",
                                        },
                                        field: {
                                            clearable: true,
                                            onClear: () => {
                                                onFieldChange("date", null);
                                                onRestErrorKey("date");
                                            }
                                        }
                                    }}
                                    sx={{ width: "100%" }}
                                    format={fieldDateFormat}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid size={{ md: 12, xs: 12 }}>
                            <TextField
                                disabled={modeType === "view"}
                                id="notes"
                                label="Notes"
                                variant="outlined"
                                size="small"
                                margin="normal"
                                slotProps={{ inputLabel: { shrink: true } }}
                                sx={{ '& .MuiInputBase-input': { resize: 'vertical', overflow: 'auto' } }}
                                onChange={(e) => { onFieldChange('notes', e.target.value.trimStart()) }}
                                value={data?.notes || ''}
                                error={!!error.notes}
                                helperText={error.notes}
                                fullWidth
                                multiline
                                rows={3}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions sx={{ marginRight: "15px" }}>
                    <Button className='cancel-btn' disabled={isLoading} variant="outlined" size='small' onClick={() => { onToggleModal(); handleItemClicked('Cancel Button') }}>{modeType === "view" ? "Close" : "Cancel"}</Button>
                    {modeType === "view" ? null :
                        <Button variant="contained" size='small' className="btn-primary" onClick={() => { handleItemClicked('Save Button'); onAddEditHolidayList() }}>
                            {isLoading ? <CircularProgress size={24} color="inherit" /> : "SAVE"}
                        </Button>}
                </DialogActions>
            </Dialog>
        </>
    )
}

export default HolidayCru 